import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import userReducer from "./slices/userSlice";
import notificationReducer from "./slices/notificationSlice";
import analyticsReducer from "./slices/analyticsSlice";
import reportReducer from "./slices/reportSlice";
import categoryReducer from "./slices/categorySlice";
import questionReducer from "./slices/questionSlice";
import dailyQuizReducer from "./slices/dailyQuizSlice";
import courseReducer from "./slices/courseSlice";
import languageReducer from "./slices/languageSlice";
import contentReducer from "./slices/contentSlice";
import fileReducer from "./slices/fileSlice";
import settingsReducer from "./slices/settingsSlice";
import multilingualStringReducer from "./slices/multilingualStringSlice";
import certificateTemplateReducer from "./slices/certificateTemplateSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: userReducer,
    notifications: notificationReducer,
    analytics: analyticsReducer,
    reports: reportReducer,
    category: categoryReducer,
    question: questionReducer,
    dailyQuiz: dailyQuizReducer,
    course: courseReducer,
    language: languageReducer,
    content: contentReducer,
    files: fileReducer,
    settings: settingsReducer,
    multilingualString: multilingualStringReducer,
    certificateTemplate: certificateTemplateReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["auth/loginSuccess"],
        ignoredPaths: ["auth.user"],
      },
    }),
});
